// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 0a16 16 0 1016 16A16 16 0 0016 0zm4.73 13.67l-5.49 6.06a1 1 0 01-.72.33 1 1 0 01-.71-.3l-2.5-2.56a1 1 0 111.43-1.4l1.76 1.8 4.77-5.27a1 1 0 111.48 1.34z"/></svg>
);

export default fn;
